import React, {useContext} from 'react';
import {SectionsContext} from "../contexts/SectionsProvider";
import {MortgageContext} from "../contexts/MortgageProvider";
import Menu from "../ui/outlet-views/Menu";

function UploadMenu(props) {
    //const context = useContext(ApplySectionContext)
    const mortgageContext = useContext(MortgageContext)
    const sectionsContext = useContext(SectionsContext)
    const getSectionProgress = (name) => {
       return 0
    }
    const getApplicantProgress = (applicant) => {
        return 0
    }
    const items = [
        {
            title: 'Your supporting documents',
            link: '/upload-1',
            progress: getApplicantProgress(1),
        }
    ]
    if (mortgageContext.mortgage.twoApplicants) {
        let name = mortgageContext.mortgage.applicant2.firstName || 'The other applicant'
        items.push({
            title: `${name}'s supporting documents`,
            link: '/upload-2',
            progress: getApplicantProgress(2),
        })
    }
    if (mortgageContext.mortgage.requirement?.depositGifts && mortgageContext.mortgage.requirement.depositGifts > 0) {
        items.push({
            title: 'Gift Evidence',
            progress: getSectionProgress('gift-evidence'),
            link: 'gift-evidence',
        })
    }
    items.push({
        title: `Any other documents`,
        link: 'other-documents',
        progress: getSectionProgress('other-documents'),
    })
    return <Menu
        title={'Upload your documentation'}
        back={'/'}
        progress={0}
        items={items}

    >

    </Menu>
}
export default UploadMenu;